import React, { useState, useRef, useCallback, useEffect } from "react";
import PanelCanvas2D from "./2DLayoutComponents/PanelCanvas2D";
import PanelCanvasReal3D from "./3DLayoutRealComponents/PanelCanvasReal3D";
import './PanelCanvas.css';

export default function PanelCanvas({ onSceneReady, onLoadingChange, onViewModeChange, toolbarLeft, ...props }) {
  const [viewMode, setViewMode] = useState("2D");
  const [canFit, setCanFit] = useState(false);
  const fitRef = useRef(null);

  // The WebGPU engine (and its GPU memory) only exists once the user has
  // actually asked for the 3D view. Before that, PanelCanvasReal3D isn't
  // mounted at all — not even hidden — so there's no init cost while
  // someone stays on 2D. Once it has been requested, we keep it mounted
  // (just hidden) so switching back and forth doesn't rebuild the scene
  // every time. If that hidden GPU context turns out to be too costly to
  // keep around, unmount on leaving 3DReal instead — the tradeoff there is
  // "cheap tab switches" vs "always tearing down the engine".
  const [has3DBeenRequested, setHas3DBeenRequested] = useState(false);
  const [is3DLoading, setIs3DLoading] = useState(false);
  const [is3DFirstLoading, setIs3DFirstLoading] = useState(false);
  const first3DDoneRef = useRef(false);

  useEffect(() => { onViewModeChange?.(viewMode); }, [viewMode, onViewModeChange]);
  const showReal3D = () => {
    if (!has3DBeenRequested) {
      setIs3DFirstLoading(true);
      // let the spinner paint before the WebGPU init starts
      requestAnimationFrame(() =>
        requestAnimationFrame(() => setHas3DBeenRequested(true))
      );
    }
    setViewMode("3DReal");
  };

  // Only the 3D canvas uses this. It ends the *first* load only.
  const handle3DLoadingChange = useCallback((loading) => {
    onLoadingChange?.(loading); // keep the existing behaviour
    if (!loading && !first3DDoneRef.current) {
      first3DDoneRef.current = true;
      setIs3DFirstLoading(false);
    }
  }, [onLoadingChange]);

  // handleSceneReady goes back to the original version (no loading logic):
  const handleSceneReady = useCallback((payload) => {
    fitRef.current = payload?.onFit ?? null;
    setCanFit(!!payload?.onFit);
    onSceneReady?.(payload);
  }, [onSceneReady]);

  // const showReal3D = () => {
  //   setHas3DBeenRequested(true);
  //   setViewMode("3DReal");
  // };

  // const handleSceneReady = useCallback((payload) => {
  //   fitRef.current = payload?.onFit ?? null;
  //   setCanFit(!!payload?.onFit);
  //   onSceneReady?.(payload);
  // // }, [onSceneReady]);

  // const showReal3D = () => {
  //   if (!has3DBeenRequested) {
  //     setIs3DLoading(true);
  //     // let the spinner paint before the heavy WebGPU init blocks the main thread
  //     requestAnimationFrame(() =>
  //       requestAnimationFrame(() => setHas3DBeenRequested(true))
  //     );
  //   }
  //   setViewMode("3DReal");
  // };

  // const handleSceneReady = useCallback((payload) => {
  //   console.log("onSceneReady fired", payload); // temporary, to check timing
  //   fitRef.current = payload?.onFit ?? null;
  //   setCanFit(!!payload?.onFit);
  //   if (payload?.onFit) setIs3DLoading(false);
  //   onSceneReady?.(payload);
  // }, [onSceneReady]);

  return (
    // <div>
    <div className="panel-canvas-container">
      {/* Toolbar */}
      <div className="panel-canvas-toolbar">
        {/* <h3 style={{ margin: 0 }}>Panel Layout Proposal:</h3> */}
        <div className="panel-canvas-toolbar-left">{toolbarLeft}</div>

        <div div className="panel-canvas-toolbar-right">
          <button
            onClick={() => setViewMode("2D")}
            style={{
              background: viewMode === "2D" ? "#0078ff" : "#ddd",
              color: viewMode === "2D" ? "white" : "black",
              padding: "6px 12px",
              borderRadius: "6px",
            }}
          >
            2D
          </button>

          <button
            onClick={showReal3D}
            style={{
              background: viewMode === "3DReal" ? "#0078ff" : "#ddd",
              color: viewMode === "3DReal" ? "white" : "black",
              padding: "6px 12px",
              borderRadius: "6px",
            }}
          >
            3D
          </button>
        </div>
      </div>

      {/* Conditional views */}

      <div className="canvas-view">
        {is3DFirstLoading && (
          <div className="canvas-loading-overlay">
            <div className="canvas-loading-spinner" />
          </div>
        )}
        <div
          style={{
            display: viewMode === "2D" ? "block" : "none",
            width: "100%",
            height: "100%",
          }}
        >
          <PanelCanvas2D {...props} />
        </div>

        {has3DBeenRequested && (
          <div
            style={{
              display: viewMode === "3DReal" ? "block" : "none",
              width: "100%",
              height: "100%",
            }}
          >
            <PanelCanvasReal3D
              {...props}
              onLoadingChange={handle3DLoadingChange}
              onSceneReady={handleSceneReady}
            />
          </div>
        )}
      </div>
    </div >
  );
}
